import { render, staticRenderFns } from "./instantPayment.vue?vue&type=template&id=da68e97a&scoped=true"
import script from "./instantPayment.vue?vue&type=script&lang=js"
export * from "./instantPayment.vue?vue&type=script&lang=js"
import style0 from "./instantPayment.vue?vue&type=style&index=0&id=da68e97a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da68e97a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da68e97a')) {
      api.createRecord('da68e97a', component.options)
    } else {
      api.reload('da68e97a', component.options)
    }
    module.hot.accept("./instantPayment.vue?vue&type=template&id=da68e97a&scoped=true", function () {
      api.rerender('da68e97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/Withdrawal/instantPayment.vue"
export default component.exports